import { render } from "./Vyroba.vue?vue&type=template&id=3222c416"
import script from "./Vyroba.vue?vue&type=script&lang=js"
export * from "./Vyroba.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__